export default import.meta.ROLLDOWN_FILE_URL_Awcadh$6K3mZw34GQ8CWdg